export default function StartDateSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="bg-gradient-to-r from-gold-400 to-gold-300 border-4 border-purple-600 rounded-3xl p-12 text-center shadow-2xl">
          <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
            <i className="ri-calendar-check-line text-purple-900 text-5xl"></i>
          </div>
          <h3 className="font-display text-4xl font-bold text-purple-900 mb-2">
            Início das aulas
          </h3>
          <p className="text-5xl font-bold text-purple-900">
            28 de março de 2026
          </p>
        </div>
      </div>
    </section>
  );
}
